// SummaryCalendar DTO
export class SummaryCalendarDTO {
    constructor({
        year = 0,
        weekCalendarNumber = 0,
        actualWorkTimeHours = 0,
        actualWorkTimeMinutes = 0,
        shouldWorkTimeHours = 0,
        shouldWorkTimeMinutes = 0,
        actualHolidayDays = 0,
        shouldHolidayDaysInYear = 0
    } = {}) {
        this.year = year;
        this.weekCalendarNumber = weekCalendarNumber;
        this.actualWorkTimeHours = actualWorkTimeHours;
        this.actualWorkTimeMinutes = actualWorkTimeMinutes;
        this.shouldWorkTimeHours = shouldWorkTimeHours;
        this.shouldWorkTimeMinutes = shouldWorkTimeMinutes;
        this.actualHolidayDays = actualHolidayDays;
        this.shouldHolidayDaysInYear = shouldHolidayDaysInYear;
    }

    deepCopy() {
        return new SummaryCalendarDTO({ ...this });
    }
}

// SummaryEmployee DTO
export class SummaryEmployeeDTO {
    constructor({
        userId = '',
        userName = '',
        email = '',
        remainingHolidays = 0,
        remainingOvertime = 0,
        totalPaidOvertimeHours = 0,
        totalPaidOvertimeMinutes = 0,
        plannedHolidayDays = 0,
        summaryCalendarEmployees = []
    } = {}) {
        this.userId = userId;
        this.userName = userName;
        this.email = email;
        this.summaryCalendarEmployees = summaryCalendarEmployees.map(c => new SummaryCalendarDTO(c));
        this.remainingHolidays = remainingHolidays;
        this.remainingOvertime = remainingOvertime;
        this.totalPaidOvertimeHours = totalPaidOvertimeHours;
        this.totalPaidOvertimeMinutes = totalPaidOvertimeMinutes;
        this.plannedHolidayDays = plannedHolidayDays;
    }

    deepCopy() {
        return new SummaryEmployeeDTO({
            userId: this.userId,
            userName: this.userName,
            email: this.email,
            remainingHolidays: this.remainingHolidays,
            remainingOvertime: this.remainingOvertime,
            totalPaidOvertimeHours: this.totalPaidOvertimeHours,
            totalPaidOvertimeMinutes: this.totalPaidOvertimeMinutes,
            plannedHolidayDays: this.plannedHolidayDays,
            summaryCalendarEmployees: this.summaryCalendarEmployees.map(c => c.deepCopy())

        });
    }
}
